/* unplugin-vue-components disabled */import script from "./TrialDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TrialDialog.vue?vue&type=script&setup=true&lang=js"

import "./TrialDialog.vue?vue&type=style&index=0&id=6cd0263d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd0263d"]])

export default __exports__